<!-- src/views/demand/components/audit-dialog.vue -->
<template>
  <el-dialog
    title="审核"
    :visible.sync="dialogVisible"
    width="500px"
    @close="handleClose"
  >
    <el-form
      ref="auditForm"
      :model="formData"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="审核结果" prop="auditStatus">
        <el-select v-model="formData.auditStatus" placeholder="请选择审核结果">
          <el-option label="通过" :value="1"></el-option>
          <el-option label="拒绝" :value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="审核说明" prop="auditRemark">
        <el-input
          v-model="formData.auditRemark"
          type="textarea"
          :rows="4"
          placeholder="请输入审核说明"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'AuditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    initialData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        auditStatus: 1,
        auditRemark: ''
      },
      rules: {
        auditStatus: [
          { required: true, message: '请选择审核结果', trigger: 'change' }
        ],
        auditRemark: [
          { required: true, message: '请输入审核说明', trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        // 弹窗打开时，重置表单
        this.$nextTick(() => {
          this.$refs.auditForm.resetFields();
        });
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val);
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    handleSubmit() {
      this.$refs.auditForm.validate((valid) => {
        if (valid) {
          // 触发提交事件
          this.$emit('submit', this.formData);
          this.handleClose();
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>

</style>